import { colors } from '@/constants';
import { RiFileList3Line } from 'react-icons/ri';
import styled from 'styled-components';

export const Empty = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 30%;
  background-color: ${colors.brand};
`;

export const EmptyIcon = styled(RiFileList3Line)`
  font-size: 30px;
  color: ${colors.gray.gray40};
`;

export const EmptyTitle = styled.h1`
  font-size: 16px;
  font-weight: 400;
  color: ${colors.gray.gray40};
  margin-top: 16px;
`;